<template>
    <Main>
        <div slot="main" class="main breeder">
            <div class="bank_title">
                <Header :data='headerInfo'></Header>
                <div v-if="goBackShow" class="gobcak" @click="goBack"><img src="../../assets/return.png"
                        alt=""><span>返回</span></div>
            </div>
            <div class="content" v-if="refreShow">
                <div class="head">
                    <div class="top_item" style="margin-left:0.63rem" v-if="headDate != '/nmzlqlogin'">
                        <span>平台服务牛只(头)</span>
                        <div class="small_big">{{ head.cowLivestockCount }}
                            <div class="top_box"></div>
                        </div>
                    </div>
                    <div class="top_item" style="margin-left:3.2rem" v-else>
                        <span>平台服务牛只(头)</span>
                        <div class="small_big">{{ head.cowLivestockCount }}
                            <div class="top_box"></div>
                        </div>
                    </div>
                    <!-- <div class="top_item" v-show="headDate != '/nmzlqlogin'">
                        <span>平台服务羊只(只)</span>
                        <div class="small_big">{{ head.sheepLivestockCount }}
                            <div class="top_box"></div>
                        </div>
                    </div> -->
                    <div class="top_item">
                        <span>平台服务母牛(头)</span>
                        <div class="small_big">{{ head.bossyLivestockCount }}
                            <div class="top_box"></div>
                        </div>
                    </div>
                    <div class="top_item">
                        <span style="min-width: 3rem;">{{ headDate != '/nmzlqlogin' ? '平台服务公牛(头)' : '育肥牛' }}</span>
                        <div class="small_big">{{ head.breedingOxenCount }}
                            <div class="top_box"></div>
                        </div>
                    </div>
                    <div class="top_item">
                        <span>区域牛只免疫密度</span>
                        <div class="small_big">{{ head.areaCowImmuneDensity }}
                            <span>%</span>
                            <div class="top_box"></div>
                        </div>
                    </div>
                    <!-- <div class="top_item" v-show="headDate != '/nmzlqlogin'">
                        <span>区域羊只免疫密度</span>
                        <div class="small_big">{{ head.areaCowSheepDensity }}
                            <span>%</span>
                            <div class="top_box"></div>
                        </div>
                    </div> -->
                    <div class="top_item">
<!--                        <span style="min-width: 3rem;">{{ headDate != '/nmzlqlogin' ? '2022第四季度病例(例)' : '2023第一季度病例'-->
<!--                        }}</span>-->
                        <span style="min-width: 3rem;">{{this.currentYear}}{{this.currentQuarter}}{{ '病例' }}</span>
                        <div class="small_big">{{ head.fourthQuarterCases }}
                            <div class="top_box"></div>
                        </div>
                    </div>
                </div>
                <div class="foot">
                    <div class="left">
                        <div class="l_t">
                            <div class="server">
                                <div>
                                    <span class="card_">存栏品类分布</span>
                                    <img style="margin-left: 0.25rem;" src="../../assets/hhr_right.png" alt="">
                                </div>
                                <div class="date" v-show="headDate != '/nmzlqlogin'">
                                    <span @click="serviceStatusBtn('牛')" :class="{ active: serviceStatus === '牛' }">牛</span>
                                    <!-- <span @click="serviceStatusBtn('羊')" :class="{ active: serviceStatus === '羊' }">羊</span> -->
                                </div>
                            </div>
                            <div id="barChart"></div>
                        </div>
                        <div class="l_b">
                            <div class="server">
                                <div>
                                    <span class="card_">出栏动态</span>
                                    <img style="margin-left: 0.25rem;" src="../../assets/hhr_right.png" alt="">
                                </div>
                                <div class="date">
                                    <span @click="statusBtn('three')" :class="{ active: status === 'three' }">近3月</span>
                                    <span @click="statusBtn('six')" :class="{ active: status === 'six' }">近6月</span>
                                    <span @click="statusBtn('all')" :class="{ active: status === 'all' }">本年度</span>
                                </div>
                            </div>
                            <div class="add" v-if="marketData.length">
                                <div class="add_item">
                                    <span class="num">{{ marketData[0].cropAmount }}</span>
                                    <div style="margin-top: 0.11rem;">
                                        <span>牛只出栏(头)</span>
                                        <span :class="{ active_1: marketData[0].flag == 0 }">同比
                                            <i>{{ marketData[0].rate }}
                                            </i>
                                        </span>
                                        <img v-if="marketData[0].flag !== 0" src="../../assets/icon_down_1.png" alt="">
                                        <img v-else src="../../assets/icon_up_1.png" alt="">
                                    </div>
                                </div>
                                <!-- <div class="add_item" v-show="headDate != '/nmzlqlogin'">
                                    <span class="num">{{ marketData[1].cropAmount }}</span>
                                    <div style="margin-top: 0.11rem;">
                                        <span>羊只出栏(只)</span>
                                        <span :class="{ active_1: marketData[1].flag == 0 }">同比 <i>{{
                                            marketData[1].rate
                                        }}
                                            </i>
                                        </span>
                                        <img v-if="marketData[1].flag !== 0" src="../../assets/icon_down_1.png" alt="">
                                        <img v-else src="../../assets/icon_up_1.png" alt="">
                                    </div>
                                </div> -->
                            </div>
                            <div id="lineChart_1"></div>
                        </div>
                    </div>
                    <div class="center">
                        <div class="center_top">
                            <!-- <img @click="btnClick" src="../../assets/left_map.png" alt=""
                                v-show="headDate != '/nmzlqlogin'"> -->
                            <span @click="btnClick(item,i)" v-show="textShow" v-for="(item, i) in arr" :key="i"
                                :class="{ active_2: i == 1 }">{{
                                    item == '繁殖率分布' ? '' : item
                                }}</span>
                                  <!-- item == '繁殖率分布' && headDate == '/nmzlqlogin' ? '' : item -->
                            <!-- <img @click="btnClick" src="../../assets/right_map.png" alt=""
                                v-show="headDate != '/nmzlqlogin'"> -->
                        </div>
                        <div class="date" v-if="arr[1] == '疫病分布'">
                            <span @click="monthStatusBtn('threeMonth')"
                                :class="{ active: monthStatus === 'threeMonth' }">近3月</span>
                            <span @click="monthStatusBtn('sixMonth')"
                                :class="{ active: monthStatus === 'sixMonth' }">近6月</span>
                            <span @click="monthStatusBtn('allMonth')"
                                :class="{ active: monthStatus === 'allMonth' }">本年度</span>
                        </div>
                        <div v-if="arr[1] !== '疫病分布'" class="span_item"></div>
                        <div v-if="isShowMap" id="map"></div>
                        <div class="bottom" v-show="headDate != '/nmzlqlogin'">
                            <div class="server">
                                <div>
                                    <span class="card_">母牛繁育概览</span>
                                    <img style="margin-left: 0.25rem;" src="../../assets/hhr_right.png" alt="">
                                </div>
                                <div class="date">
                                    <span @click="markStatusBtn('2025')"
                                        :class="{ active: markStatus === '2025' }">2025年</span>
                                    <span @click="markStatusBtn('2024')"
                                        :class="{ active: markStatus === '2024' }">2024年</span>
                                    <span @click="markStatusBtn('2023')"
                                        :class="{ active: markStatus === '2023' }">2023年</span>
                                </div>
                            </div>
                            <div class="bottom_">
                                <!--      <div class="round">
                                    <span>{{ this.bossyBreedOverview.breedingRate + '%' }}</span>
                                    <span>繁殖率</span>
                                    <dv-water-level-pond :config="config1" style="width:1.25rem;height:1.25rem" />
                                </div> -->
                                <!-- <div class="bottom_item">
                                    <span class="col" style="background: #00E0DB;"></span>
                                    <div class="item">
                                        <span>参配率</span>
                                        <span>{{ bossyBreedOverview.joinBreedingRate }}</span>
                                    </div>
                                </div>
                                <div class="bottom_item">
                                    <span class="col" style="background: #2C76FE;"></span>
                                    <div class="item">
                                        <span>受胎率</span>
                                        <span>{{ bossyBreedOverview.pregnancyRate }}</span>
                                    </div>
                                </div> -->
                                <!-- <div class="bottom_item">
                                    <span class="col" style="background: #5D2CFE;"></span>
                                    <div class="item">
                                        <span>流产率</span>
                                        <span>{{ bossyBreedOverview.abortionRate }}</span>
                                    </div>
                                </div> -->
                                <div class="bottom_item">
                                    <span class="col" style="background: #FFE11D;"></span>
                                    <div class="item">
                                        <span>繁殖成活率</span>
                                        <!-- <span>{{ bossyBreedOverview.survivalRate }}</span> -->
                                        <span>{{ hashSurvivalRate[markStatus] }}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="right">
                        <div class="server">
                            <div>
                                <span class="card_">动保防疫概览</span>
                                <img style="margin-left: 0.25rem;" src="../../assets/hhr_right.png" alt="">
                            </div>
                            <div class="date">
                                <span @click="monthStatusBtn_('threeMonth_')"
                                    :class="{ active: monthStatus_ === 'threeMonth_' }">近3月</span>
                                <span @click="monthStatusBtn_('sixMonth_')"
                                    :class="{ active: monthStatus_ === 'sixMonth_' }">近6月</span>
                                <span @click="monthStatusBtn_('allMonth_')"
                                    :class="{ active: monthStatus_ === 'allMonth_' }">本年度</span>
                            </div>
                        </div>
                        <div class="add">
                            <div class="add_item">
                                <span class="num">{{ animalData.cowAttackCount }}</span>
                                <div style="margin-top: 0.11rem;">
                                    <span>牛只发病数(头)</span>
                                </div>
                            </div>
                            <!-- <div class="add_item" v-show="headDate != '/nmzlqlogin'">
                                <span class="num">{{ animalData.sheepAttackCount }}</span>
                                <div style="margin-top: 0.11rem;">
                                    <span>羊只发病数(只)</span>
                                </div>
                            </div> -->
                        </div>
                        <div class="block">
                            <span></span>
                            <span>发病数时间分布</span>
                        </div>
                        <div id="lineChart_2"></div>
                        <div class="block_" style="margin-top:0rem">
                            <div class="block_item">
                                <span></span>
                                <span>发病病种分布</span>
                            </div>
                            <div class="date" v-show="headDate != '/nmzlqlogin'">
                                <span @click="cattleStatusBtn('牛')" :class="{ active: cattleStatus === '牛' }">牛</span>
                                <!-- <span @click="cattleStatusBtn('羊')" :class="{ active: cattleStatus === '羊' }">羊</span> -->
                            </div>
                        </div>
                        <dv-scroll-ranking-board :config="config"
                            style="width:5.3rem;height:3.8rem;margin-top:0.4rem;margin-left: .5rem;" />
                    </div>
                </div>
                <video src="../../assets/66.mp4" muted autoplay="autoplay" loop="loop"></video>
            </div>

        </div>
    </Main>
</template>
  
<script>
import Main from "@/components/main.vue";
import Header from "../../components/headerXn.vue";

export default {
    components: {
        Main,
        Header,
        // XChart
    },
    data() {
        return {
            isShowMap: true,
            textShow: true,
            config: {

            },
            config1: {

            },
            headerInfo: {},
            userInfo: {},
            serviceStatus: '牛',
            status: 'three',
            monthStatus: 'threeMonth',
            cattleStatus: '牛',
            monthStatus_: 'threeMonth_',
            text: '疫病分布',
            region: {},
            screenData: {},
            arr: ['疫病分布', '存栏分布', '繁殖率分布'],
            lineData: [],
            barData: [],//柱状图
            mapData: {},//存储多个地图数据
            chart: {},//地图实例
            head: {},//存储头部信息
            livestockKindDis: {}, // 存栏品类分布
            bossyBreedOverview: {},//母牛繁育概览信息
            hashSurvivalRate: {
                '2025': '98.72%',
                '2024': '98.41%',
                '2023': '97.65%',
            },
            entityDis: {},//发病病种分布
            marketDynamicState: {},//出栏动态
            marketData: [],//存储单个出栏动态
            animalAntiOverview: {}, // 动物防疫概览
            animalData: {},//存储单个动物防疫概览
            num1: 0,//地图图例为分段式的平均值
            num2: 0,
            childMap: [],//地图下钻数据集合
            childMapData: [],//地图下钻数据
            goBackShow: false,//上一层
            pieces: [],
            pieces_: [],
            paramsName: '',//下钻省保存省名
            refreShow: true,
            markStatus: '2025',//繁育概览标识
            headDate: '',//判断是否为正蓝旗登录
            currentYear: '',
            currentQuarter: '',
            mapDistance:90, //地图缩放距离
            mapDistance2:110 //子地图缩放距离
        };
    },
    watch: {},
    created() {
        this.headDate = window.localStorage.getItem('LOGIN')
        this.headerInfo = {
            name: window.localStorage.getItem('screenName')
        }
        this.userInfo = JSON.parse(window.localStorage.getItem('NMYDATAUSERINFO'))

        let m = new Date().getMonth()
        if (m <= 3) {
            this.currentQuarter = '第四季度';
            this.currentYear = new Date().getFullYear() - 1;
        } else if ( 4 <= m && m <= 6) {
            this.currentQuarter = '第一季度';
            this.currentYear = new Date().getFullYear();
        } else if ( 7 <= m && m <= 9) {
            this.currentQuarter = '第二季度';
            this.currentYear = new Date().getFullYear();
        } else if ( 10 <= m) {
            this.currentQuarter = '第三季度';
            this.currentYear = new Date().getFullYear();
        }
    },
    mounted() {
        this.getData()
    },
    methods: {
        // 返回上一层
        goBack() {
            this.goBackShow = false
            // this.$router.go(0)
            this.refreShow = false
            this.$nextTick(() => {
                this.refreShow = true
                this.getData()
            })
        },
        btnClick(val,i) {
            if(this.arr[1]==val){
                return
            }
            this.textShow = false
            this.$nextTick(() => {
                this.textShow = true
                if (val && val == this.arr[0]) {
                    var a = this.arr[0]
                    this.arr[0] = this.arr[2]
                    this.arr[2] = this.arr[1]
                    this.arr[1] = a
                } else {
                    var b = this.arr[0]
                    this.arr[0] = this.arr[1]
                    this.arr[1] = this.arr[2]
                    this.arr[2] = b
                }

                if (this.chart != null && this.chart != "" && this.chart != undefined) {
                    this.isShowMap = false
                    // this.chart.dispose()
                }
                if (this.arr[1] == '疫病分布') {
                    this.$nextTick(() => {
                        this.isShowMap = true
                        setTimeout(() => {
                            this.childMap = this.mapData.diseaseDis.three
                            if (this.goBackShow) {
                                this.childMapDataList()
                            } else {
                                if (this.region.features[0].properties.country == '正蓝旗') {
                                    this.draws(this.region, this.mapData.diseaseDis.three)
                                } else {
                                    this.draw(this.region, this.mapData.diseaseDis.three)
                                }
                            }
                        }, 100)
                    })
                }
                if (this.arr[1] == '存栏分布') {
                    this.$nextTick(() => {
                        this.isShowMap = true
                        setTimeout(() => {
                            this.childMap = this.mapData.livestockDis
                            if (this.goBackShow) {
                                this.childMapDataList()

                            } else {
                                if (this.region.features[0].properties.country == '正蓝旗') {
                                    this.drawsHeatMap(this.region)
                                } else {
                                    this.draw(this.region, this.mapData.livestockDis)
                                }
                            }
                        }, 100)
                    })
                }
                if (this.arr[1] == '繁殖率分布') {
                    this.$nextTick(() => {
                        this.isShowMap = true
                        setTimeout(() => {
                            this.childMap = this.mapData.breedingDis
                            console.log(this.childMap, 'this.childMap');
                            if (this.goBackShow) {
                                this.childMapDataList()

                            } else {
                                if (this.region.features[0].properties.country == '正蓝旗') {
                                    this.draws(this.region, this.mapData.breedingDis)
                                } else {
                                    this.draw(this.region, this.mapData.breedingDis)
                                }
                            }
                        }, 100)
                    })
                }

            })

            // var spans = document.querySelectorAll('.center_top span')
            // spans[0].style.transform = "translateX(270px)"
            // spans[0].style.transition = "transform 1s linear"
            // spans[1].style.transform = "translateX(-135px)"
            // spans[1].style.transition = "transform 1s linear"
            // spans[2].style.transform = "translateX(-135px)"
            // spans[2].style.transition = "transform 1s linear"
        },
        childMapDataList() {
            this.childMapData = this.childMap.filter(item => {
                return this.paramsName == item.city
            })
            this.draw(this.region, this.childMapData[0].childMap)
        },
        serviceStatusBtn(val) {
            this.barData = []
            if (val === '牛') {
                this.serviceStatus = '牛'
                this.barData = [{ title: "牛只", value: this.livestockKindDis.cow.value, label: this.livestockKindDis.cow.label }]
            }
            if (val === '羊') {
                this.serviceStatus = '羊'
                this.barData = [{ title: "羊只", value: this.livestockKindDis.sheep.value, label: this.livestockKindDis.sheep.label },]

            }
            this.setBarData(this.barData)
        },
        statusBtn(val) {
            this.marketData = []
            if (val === 'three') {
                this.status = 'three'
                // this.marketDynamicState.nearThreeMonth.title = '牛只'
                this.marketData = [
                    this.marketDynamicState.cow.nearThreeMonth,
                    this.marketDynamicState.sheep.nearThreeMonth,
                ]
            }
            if (val === 'six') {
                this.status = 'six'
                this.marketData = [
                    this.marketDynamicState.cow.nearSixMonth,
                    this.marketDynamicState.sheep.nearSixMonth,
                ]
            }
            if (val === 'all') {
                this.status = 'all'
                this.marketData = [
                    this.marketDynamicState.cow.thisYear,
                    this.marketDynamicState.sheep.thisYear,
                ]
            }
            if (this.headDate != '/nmzlqlogin') {
                const data = [
                    { title: '牛只', label: this.marketData[0].label, value: this.marketData[0].value },
                    // { title: '羊只', label: this.marketData[1].label, value: this.marketData[1].value },
                ]
                this.setLineData(data, 'lineChart_1')

            } else {
                const data = [
                    { title: '牛只', label: this.marketData[0].label, value: this.marketData[0].value },
                ]
                this.setLineData(data, 'lineChart_1')
            }
        },
        // 地图月份切换
        monthStatusBtn(val) {
            if (this.chart != null && this.chart != "" && this.chart != undefined) {
                this.isShowMap = false
                this.chart.dispose()
            }
            if (val === 'threeMonth') {
                this.monthStatus = 'threeMonth'
                this.$nextTick(() => {
                    this.isShowMap = true
                    setTimeout(() => {
                        this.childMap = this.mapData.diseaseDis.three
                        if (this.goBackShow) {
                            this.childMapDataList()

                        } else {
                            if (this.region.features[0].properties.country == '正蓝旗') {
                                this.draws(this.region, this.mapData.diseaseDis.three)
                            } else {
                                this.draw(this.region, this.mapData.diseaseDis.three)
                            }
                        }
                    }, 100)
                })
            }
            if (val === 'sixMonth') {
                this.monthStatus = 'sixMonth'
                this.$nextTick(() => {
                    this.isShowMap = true
                    setTimeout(() => {
                        this.childMap = this.mapData.diseaseDis.six
                        if (this.goBackShow) {
                            this.childMapDataList()

                        } else {
                            if (this.region.features[0].properties.country == '正蓝旗') {
                                this.draws(this.region, this.mapData.diseaseDis.six)
                            } else {
                                this.draw(this.region, this.mapData.diseaseDis.six)
                            }
                        }
                    }, 100)
                })
            }
            if (val === 'allMonth') {
                this.monthStatus = 'allMonth'
                this.$nextTick(() => {
                    this.isShowMap = true
                    setTimeout(() => {
                        this.childMap = this.mapData.diseaseDis.year
                        if (this.goBackShow) {
                            this.childMapDataList()

                        } else {
                            if (this.region.features[0].properties.country == '正蓝旗') {
                                this.draws(this.region, this.mapData.diseaseDis.year)
                            } else {
                                this.draw(this.region, this.mapData.diseaseDis.year)
                            }
                        }
                    }, 100)
                })
            }
        },
        cattleStatusBtn(val) {
            if (val === '牛') {
                this.cattleStatus = '牛'
                const dataArr = []
                this.entityDis.cow.label.forEach(item => {
                    dataArr.push({ name: item })
                })
                this.entityDis.cow.value.forEach((item, i) => {
                    dataArr[i].value = item
                })
                this.config = {
                    data: dataArr,
                    unit: '头'
                }
            }
            if (val === '羊') {
                this.cattleStatus = '羊'
                const dataArr = []
                this.entityDis.sheep.label.forEach(item => {
                    dataArr.push({ name: item })
                })
                this.entityDis.sheep.value.forEach((item, i) => {
                    dataArr[i].value = item
                })
                this.config = {
                    data: dataArr,
                    unit: '只'
                }
            }
        },
        monthStatusBtn_(val) {
            if (val === 'threeMonth_') {
                this.monthStatus_ = 'threeMonth_'
                this.animalData = this.animalAntiOverview.three
            }
            if (val === 'sixMonth_') {
                this.monthStatus_ = 'sixMonth_'
                this.animalData = this.animalAntiOverview.six

            }
            if (val === 'allMonth_') {
                this.monthStatus_ = 'allMonth_'
                this.animalData = this.animalAntiOverview.year

            }
            if (this.headDate != '/nmzlqlogin') {
                const data = [
                    { title: '牛只', label: this.animalData.cow.label, value: this.animalData.cow.value },
                    // { title: '羊只', label: this.animalData.sheep.label, value: this.animalData.sheep.value },
                ]
                this.setLineData(data, 'lineChart_2')

            } else {
                const data = [
                    { title: '牛只', label: this.animalData.cow.label, value: this.animalData.cow.value },
                ]
                this.setLineData(data, 'lineChart_2')
            }

        },
        markStatusBtn(val) {
            this.markStatus = val
        },
        setLineData(data, dom) {
            const colors = ['#2C76FE', '#0EDAE2', '#5931FC'];
            const legend = [];
            const series = [];
            let xAxis = [];
            data.forEach((item, index) => {
                legend.push({
                    name: item.title,
                    textStyle: { color: '#FFFFFF' },
                    icon: 'circle',
                    itemWidth: 4,
                    itemhight: 4,
                })
                xAxis = item.label
                series.push({
                    name: item.title,
                    type: "line",
                    lineStyle: {
                        width: 2,
                    },
                    color: colors[index],
                    data: item.value,
                })
            })
            const line = {
                dom,
                xAxis,
                legend: {
                    data: legend,
                    // x: 'right',
                    // y: 'top',
                    top: "1%",
                    right: "4%",
                    itemWidth: 8,
                    itemHeight: 8,
                    padding: [10, 0, 0, 0],
                },
                series: series
            }
            this.lineChart(line)
        },
        lineChart(data) {
            var linechart = this.$echarts.init(document.getElementById(data.dom))
            // 隐藏动画加载效果。
            var option = {
                color: ['#106BDC', '#0EDAE2', '#5931FC'],
                tooltip: {
                    trigger: 'axis',
                    // formatter: function (params) {
                    //     // console.log(params, 'params');
                    //     // return `<p>
                    //     //           <span style="color: #FFF; font-size: 14px; font-weight: normal;">监管笔数${params.name
                    //     //     }： ${params.data.account || 0} </span>

                    //     //       </p>`;
                    //     return `
                    //     <p style="font-size: 14px; font-weight: normal;">${params[0].name
                    //         }</p><br/>
                    //      <p>
                    //     <p style="font-size: 14px; font-weight: normal;">${params[0].value + '家'
                    //         }</p>
                    //      `;
                    //     // return params.name
                    // },
                    padding: [5, 20],
                    backgroundColor: 'rgba(255,255,255,0.8)',
                    // borderColor: 'rgba(18, 36, 132, 1)',
                    borderColor: '#292929',
                    borderWidth: 1,
                    textStyle: {
                        color: '#050F37',
                    },
                },
                legend: data.legend,
                grid: {
                    top: '25%',
                    left: '9%',
                    right: '4%',
                    bottom: '10%',
                    containLabel: true,
                },
                xAxis: {
                    type: 'category',
                    boundaryGap: true,
                    axisLabel: {
                        color: '#FFFFFF',
                    },
                    axisLine: {
                        show: true, // X轴 网格线 颜色类型的修改
                        lineStyle: {
                            color: '#075F73',
                        },
                    },
                    axisTick: {
                        // X轴线 刻度线
                        show: true,
                        inside: true,
                        alignWithLabel: true
                    },
                    data: data.xAxis,
                },
                yAxis: {
                    name: '数量',
                    nameTextStyle: {
                        color: '#FFFFFF',
                        padding: [3, 38, 0, 0],
                        lineHeight: 60,
                        // align:'left'
                    },
                    // nameLocation:'end',
                    type: 'value',
                    splitNumber: 3,
                    axisLine: {
                        show: false, // Y轴线
                        lineStyle: {
                            color: 'rgba(85, 193, 255, 1)',
                        },
                    },
                    splitLine: {
                        lineStyle: {
                            type: 'dashed',
                            color: 'rgba(255,255,255,0.05)'
                        }
                    },
                    axisLabel: {
                        color: '#FFFFFF',
                    },
                },
                series: data.series,
            }
            linechart.clear();
            linechart.setOption(option)
            window.addEventListener('resize', () => {
                linechart.resize()
            })
        },
        // 牛羊只存栏柱状图
        setBarData(data) {
            var barchart = this.$echarts.init(document.getElementById('barChart'))
            // 隐藏动画加载效果。
            var option = {
                title: {
                    text: '',
                    textAlign: 'left',
                    textStyle: {
                        color: '#00DAC8', // 主标题文字的颜色。
                        fontSize: 18, // 字体大小
                        lineHeight: '30', // 行高
                    },
                    triggerEvent: false, // 是否触发事件
                    x: 'center',
                },
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                        type: 'shadow',
                    },
                    formatter: function (params) {
                        // console.log(params,'params');
                        return `
                        <p style="font-size: 14px; font-weight: normal;">${params[0].name
                            }</p><br/>
                         <p>
                        <p style="font-size: 14px; font-weight: normal;">${params[0].value + '头'
                            }</p>
                         `;
                    },
                    // backgroundColor: 'rgba(11, 15, 56, 1)',
                    backgroundColor: 'rgba(255,255,255,0.8)',
                    // borderColor: 'rgba(18, 36, 132, 1)',
                    borderColor: '#292929',
                    borderWidth: 1,
                    textStyle: {
                        color: '#050F37',
                    },
                },
                legend: '',
                grid: {
                    top: '25%',
                    // 20
                    left: '7%',
                    right: '4%',
                    bottom: '3%',
                    // height: '150px',
                    // 130
                    // 150
                    containLabel: true,
                },
                xAxis: {
                    type: 'category',
                    boundaryGap: true,
                    axisLabel: {
                        color: '#FFFFFF',
                        rotate: 30,
                        // interval: 'auto',
                        textStyle: {
                            fontSize: 12
                        },
                    },
                    axisLine: {
                        show: true, // X轴 网格线 颜色类型的修改
                        lineStyle: {
                            color: '#075F73',
                        },
                    },
                    axisTick: {
                        // X轴线 刻度线
                        show: true,
                        inside: true,
                        alignWithLabel: true,
                        // interval: 0,
                        // alignWithLabel:1,
                        lineStyle: {
                            dashOffset: 5
                        },
                        // length:10
                    },
                    data: data[0].label,
                },
                yAxis: {
                    name: '数量(头)',
                    // name:this.cattleStatus=="cattle"?'数量(头)':'数量',
                    nameTextStyle: {
                        color: '#FFFFFF',
                        padding: [3, 50, 0, 0],
                        lineHeight: 60,
                    },
                    type: 'value',
                    splitNumber: 4,
                    splitLine: {
                        lineStyle: {
                            type: 'dashed',
                            color: 'rgba(255,255,255,0.05)'
                        }
                    },
                    axisTick: { show: false },

                    axisLine: {
                        show: false, // Y轴线
                        lineStyle: {
                            color: '#6FB6FF',
                        },
                    },
                    axisLabel: {
                        color: '#FFFFFF',
                        textStyle: {
                            fontSize: 12
                        }
                    },
                },
                series: {
                    // name: barData.name,
                    type: 'bar',
                    barWidth: '15',
                    barGap: 0,
                    emphasis: {
                        focus: "series",
                    },
                    backgroundStyle: {
                        // color: 'rgba(44, 118, 254, 0.2)'
                        color: '#00E0DB'
                    },
                    itemStyle: {
                        // opacity: 0.8,
                        // color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                        //     {
                        //         offset: 1,
                        //         color: "#297DFC",
                        //     },
                        //     {
                        //         offset: 0,
                        //         color: "#06FDF5",
                        //     },
                        // ]),
                        color: "#00E0DB"
                    },
                    data: data[0].value,
                },
            }
            barchart.clear();
            barchart.setOption(option)
            window.addEventListener('resize', () => {
                barchart.resize()
            })
        },
        getData() {
            this.$http({
                url: 'screenapp-service/screenLivestockAnalysis/select',
                //请求方式
                method: 'post',
                //传递的参数
                data: {
                    deptId: this.userInfo.dept.deptId,
                    "parentId": "0",
                    "menuMark": "11"

                },
            }).then(res => {
                const data = res.data
                if (res.data.code === 200) {
                    const screenData = JSON.parse(data.result.screenData)
                    console.log(screenData, 'data');
                    this.head = screenData.head
                    this.head.areaCowImmuneDensity =parseFloat(screenData.head.areaCowImmuneDensity) 
                    this.head.areaCowSheepDensity =parseFloat(screenData.head.areaCowSheepDensity)
                    // slice(0, 5)
                    this.bossyBreedOverview = screenData.bossyBreedOverview
                    const config_data = []
                    this.bossyBreedOverview.breedingRate = this.bossyBreedOverview.breedingRate.slice(0, 5)
                    config_data.push(this.bossyBreedOverview.breedingRate)
                    this.config1 = {
                        data: [70],
                        shape: 'round',
                        waveNum: 1,
                        waveHeight: 5,
                        colors: ['#2BF39B', '#13B3DB'],
                        waveOpacity: 1
                    }
                    this.entityDis = screenData.entityDis
                    this.livestockKindDis = screenData.livestockKindDis
                    this.marketDynamicState = screenData.marketDynamicState
                    this.animalAntiOverview = screenData.animalAntiOverview
                    this.animalData = this.animalAntiOverview.three
                    this.mapData = screenData.map//地图数据
                    console.log(this.arr[1], 'this.arr[1]');
                    if (this.arr[1] == '疾病分布') {
                        this.childMap = this.mapData.diseaseDis.three
                    }
                    if (this.arr[1] == '存栏分布') {
                        this.childMap = this.mapData.livestockDis
                    }
                    if (this.arr[1] == '繁殖率分布') {
                        this.childMap = this.mapData.breedingDis
                    }
                    if(screenData.mapDistance){
                        this.mapDistance = Number(screenData.mapDistance);
                    }
                    this.statusBtn('three')
                    this.cattleStatusBtn('牛')
                    this.serviceStatusBtn('牛')
                    this.monthStatusBtn_('threeMonth_')
                    this.getMap()

                }
            })
        },
        getMap() {
            this.$http({
                url: 'screenapp-service/baseScreenEnterpriseInfo/select/mapData',
                //请求方式
                method: 'post',
                //传递的参数
                data: {
                    deptId: this.userInfo.dept.deptId,
                },
            }).then(res => {
                if (res.data.code === 200) {
                    this.region = res.data.result.json;
                    // console.log(this.region);
                    if (this.region.features[0].properties.country == '正蓝旗') {
                        this.drawsHeatMap(this.region, this.childMap)
                    } else {
                        this.draw(this.region, this.childMap)
                    }

                }
            })
        },
        // 正蓝旗热力图
        drawsHeatMap(geoJson) {
            // console.log(geoJson,'geoJson');
            // console.log(geoJson, 234);
            // console.log(data, 123);
            // 基于准备好的dom，初始化echarts实例
            this.chart = this.$echarts.init(document.getElementById("map"));
            this.$echarts.registerMap('GD', geoJson);
            let data = [
                ['116.158430112977', '42.8426140522395', 260],//赛音呼都嘎苏木乡
                ['115.887591014485', '42.9047850462557', 286],//那日图苏木乡
                ['115.936932911947', '41.9696109107532', 224],//黑城子示范区
                ['115.580376925441', '42.8669839246449', 287],//扎格斯台苏木乡
                ['115.641299118031', '42.2547129144455', 454],//哈毕日嘎镇
                ['115.613881921393', '42.5079359815629', 234],//宝绍代苏木乡
                // ['115.724337808832', '42.2433489074685', 500],//上都镇
                // ['115.764337808832', '42.2833489074685', 490],//上都镇
                ['115.904337808832', '42.3033489074685', 480],//上都镇
                ['115.864337808832', '42.2433489074685', 500],//上都镇
                ['116.231843112159', '42.3435590074122', 310],//五一种畜场总场
                ['115.893910088668', '42.580423003749', 341],//桑根达来镇
            ];
            let areaData = [];
            data.map((item) => {
                // 扩大热力图效果
                areaData.push(...new Array(4).fill(item));
            });
            let mapMax = Math.max(...data.map((item) => item[2]));
            let mapMin = Math.min(...data.map((item) => item[2]));


            var option = {
                tooltip: {
                    label: {
                        show: false,
                    },
                    textStyle: {
                        color: '#fff'
                    },
                    // 提示框
                    trigger: "item",
                    borderColor: "#00E0DB",
                    borderWidth: 1,
                    padding: 5,
                    backgroundColor: "#030b14",
                    extraCssText: "box-shadow: rgba(47, 244, 225, 0.5) 0px 0px 10px;",
                    formatter: (params) => {
                        // console.log(params, 'params');
                        return `
                            <p style="color:#00d4cf;font-size: 20px;">${params.name}</p><br/>
                          
                                  `;
                    },
                },
                visualMap: {
                    type: 'continuous',
                    show: false,
                    calculable: false,
                    right: 30,
                    bottom: 20,
                    itemWidth: 13,//图形的宽度，即长条的宽度。
                    itemHeight: 80,
                    // showLabel: !0,
                    text: [`${mapMax}`, '0'],
                    // realtime: false,
                    // calculable: true,
                    color: ['#fa0023', '#84d100', '#90ff07', '#edcc00', '#004684'],
                    min: mapMin,
                    max: mapMax,
                    // continuous: {
                    //     type: 'piecewise',
                    // itemGap: 12,
                    align: 'left',
                    // itemSymbol: 'circle',
                    // itemWidth: 8,
                    // itemHeight: 8,
                    textStyle: { color: '#fff' },
                },

                grid: {
                    height: '100%',
                    width: '100%',
                },

                geo: [
                    {
                        map: 'GD',
                        top: 'center',
                        left: '30%',
                        roam: false,
                        // width: '90%',
                        // height: '95%',
                        zoom: 1,
                        // z: 1,
                        label: {
                            normal: {
                                show: false,
                                color: 'transparent',
                                fontSize: 22,
                            }
                        },
                        emphasis: {
                            // 鼠标 hover 高亮时图形和标签的样式 (当鼠标放上去时 label和itemStyle 的样式)
                            label: {
                                // label高亮时的配置
                                show: false,
                                textStyle: {
                                    color: "#fff", // 高亮时标签颜色变为 白色
                                    fontSize: 15, // 高亮时标签字体 变大
                                },
                                // formatter: function (params) {
                                //   // console.log(params)
                                //   return params.name
                                // }
                            },
                            itemStyle: {
                                "areaColor": "#1E88E5"
                            }
                        },
                        itemStyle: {
                            // 三维地理坐标系组件 中三维图形的视觉属性，包括颜色，透明度，描边等。
                            // color: "rgba(33,80,231,1)", // 地图板块的颜色
                            color: '#0f3a67',
                            opacity: 1, // 图形的不透明度 [ default: 1 ]
                            borderWidth: 1, // (地图板块间的分隔线)图形描边的宽度。加上描边后可以更清晰的区分每个区域 [ default: 0 ]
                            borderColor: "#37C1FD", // 图形描边的颜色。[ default: #333 ]
                            normal: { // 默认地图区域样式
                                // areaColor: 'rgba(33,80,231,1)',
                                areaColor: "#0f3a67",
                                // borderColor: "#4ECEE6",
                                borderColor: "#165d7d",
                                borderWidth: 1,
                                // shadowColor: "#2C99F6",
                                // shadowOffsetY: 0,
                                // shadowBlur: 25,
                            },
                        },
                    },
                ],

                series: [
                    {
                        mapType: 'GD',
                        name: 'AQI',
                        type: 'heatmap',
                        coordinateSystem: 'geo',
                        data: areaData
                    },

                ],
            }
            this.chart.clear();
            this.chart.setOption(option);
            // chart.on('click', (ret) => {
            //     console.log(ret,'wodianle');
            // })
            window.addEventListener('resize', () => {
                this.chart.resize()
            })
        },
        // 正蓝旗
        draws(geoJson) {
            // 基于准备好的dom，初始化echarts实例
            this.chart = this.$echarts.init(document.getElementById("map"));
            // bayannaoer
            this.$echarts.registerMap("bayannaoer", geoJson);
            // 隐藏动画加载效果。
            this.chart.hideLoading();


            var option = {
                tooltip: {
                    textStyle: {
                        color: '#fff'
                    },
                    // 提示框
                    trigger: "item",
                    borderColor: "#00E0DB",
                    borderWidth: 1,
                    padding: 5,
                    backgroundColor: "#030b14",
                    extraCssText: "box-shadow: rgba(47, 244, 225, 0.5) 0px 0px 10px;",
                    formatter: (params) => {
                        // console.log(params, 'params');
                        return `
                            <p style="color:#00d4cf;font-size: 20px;">${params.name}</p><br/>
                          
                                  `;
                    },
                },
                geo: {
                    show: true,
                    // roam: true,
                    type: "map", // 系列类型
                    name: "map", // 系列名称
                    zoom: 1.2,
                    map: "bayannaoer", // 地图类型。echarts-gl 中使用的地图类型同 geo 组件相同(ECharts 中提供了两种格式的地图数据，一种是可以直接 script 标签引入的 js 文件，引入后会自动注册地图名字和数据。还有一种是 JSON 文件，需要通过 AJAX 异步加载后手动注册。)
                    // data: data,
                    // selectedMode: 'multiple',
                    label: {
                        // properties.cp
                        // 标签的相关设置
                        show: false, // (地图上的城市名称)是否显示标签 [ default: false ]
                        // distance: 10, // 标签距离图形的距离，在三维的散点图中这个距离是屏幕空间的像素值，其它图中这个距离是相对的三维距离 标签内容格式器
                        position: 'top',
                        // offset: [-10, 5],
                        textStyle: {
                            // 标签的字体样式
                            color: "white", // 地图初始化区域字体颜色
                            fontSize: 12, // 字体大小
                            opacity: 1, // 字体透明度
                            backgroundColor: "rgba(0,23,11,0)", // 字体背景色
                        },
                    },
                    select: {
                        disabled: true,
                        itemStyle: {
                            areaColor: "#1E88E5",
                            borderColor: "#21bde6",
                            borderWidth: "1"
                        },
                        label: {
                            show: false,
                            color: '#fff',
                            position: 'top'
                        },
                    },
                    blur: {
                        itemStyle: {
                            areaColor: "#1E88E5",
                            borderColor: "#21bde6",
                            borderWidth: "1"
                        }
                    },
                    label: {
                        // properties.cp
                        // 标签的相关设置
                        show: false, // (地图上的城市名称)是否显示标签 [ default: false ]
                        // distance: 10, // 标签距离图形的距离，在三维的散点图中这个距离是屏幕空间的像素值，其它图中这个距离是相对的三维距离 标签内容格式器
                        position: 'top',
                        // offset: [-10, 5],
                        textStyle: {
                            // 标签的字体样式
                            color: "white", // 地图初始化区域字体颜色
                            fontSize: 8, // 字体大小
                            opacity: 1, // 字体透明度
                            backgroundColor: "rgba(0,23,11,0)", // 字体背景色
                        },
                    },
                    itemStyle: {
                        // 三维地理坐标系组件 中三维图形的视觉属性，包括颜色，透明度，描边等。
                        // color: "rgba(33,80,231,1)", // 地图板块的颜色
                        color: '#0f3a67',
                        opacity: 1, // 图形的不透明度 [ default: 1 ]
                        borderWidth: 1, // (地图板块间的分隔线)图形描边的宽度。加上描边后可以更清晰的区分每个区域 [ default: 0 ]
                        borderColor: "#37C1FD", // 图形描边的颜色。[ default: #333 ]
                        normal: { // 默认地图区域样式
                            // areaColor: 'rgba(33,80,231,1)',
                            areaColor: "#0f3a67",
                            // borderColor: "#4ECEE6",
                            borderColor: "#165d7d",
                            borderWidth: 1,
                            // shadowColor: "#2C99F6",
                            // shadowOffsetY: 0,
                            // shadowBlur: 25,
                        },
                    },
                    emphasis: {
                        // 鼠标 hover 高亮时图形和标签的样式 (当鼠标放上去时 label和itemStyle 的样式)
                        label: {
                            // label高亮时的配置
                            show: false,
                            textStyle: {
                                color: "#fff", // 高亮时标签颜色变为 白色
                                fontSize: 15, // 高亮时标签字体 变大
                            },
                            // formatter: function (params) {
                            //   // console.log(params)
                            //   return params.name
                            // }
                        },
                        itemStyle: {
                            "areaColor": "#1E88E5"
                        }
                    },
                },
                series: [
                    {
                        color: ['#1998fb'],
                        // type: 'scatter',
                        type: 'effectScatter',
                        coordinateSystem: 'geo',
                        effectType: 'ripple',
                        rippleEffect: {
                            color: '#00FFFF',
                            number: 3,
                            scale: 5,
                            brushType: 'stroke'
                        },
                        symbolSize: 8,
                        tooltip: {
                            show: false
                        },
                        data: [
                            {
                                name: '上都镇',
                                value: [115.523490, 42.192830],
                                symbol: `circle`,
                                symbolOffset: [0, 0],//点偏移
                            },
                            {
                                name: '',
                                value: [115.523490, 42.192830],
                                symbol: `circle`,
                                symbolOffset: [100, 10],//点偏移
                            },
                            {
                                name: '',
                                value: [115.523490, 42.192830],
                                symbol: `circle`,
                                symbolOffset: [40, -60],//点偏移
                            },
                            {
                                name: '',
                                value: [115.523490, 42.192830],
                                symbol: `circle`,
                                symbolOffset: [60, -140],//点偏移
                            },
                            {
                                name: '',
                                value: [115.523490, 42.192830],
                                symbol: `circle`,
                                symbolOffset: [140, -60],//点偏移
                            },
                            {
                                name: '',
                                value: [115.523490, 42.192830],
                                symbol: `circle`,
                                symbolOffset: [180, -180],//点偏移
                            },
                            {
                                name: '',
                                value: [115.523490, 42.192830],
                                symbol: `circle`,
                                symbolOffset: [150, -120],//点偏移
                            },
                            {
                                name: '',
                                value: [115.523490, 42.192830],
                                symbol: `circle`,
                                symbolOffset: [180, -100],//点偏移
                            },
                            {
                                name: '',
                                value: [115.523490, 42.192830],
                                symbol: `circle`,
                                symbolOffset: [200, -60],//点偏移
                            },
                            {
                                name: '',
                                value: [115.523490, 42.192830],
                                symbol: `circle`,
                                symbolOffset: [220, -180],//点偏移
                            },
                            {
                                name: '',
                                value: [115.523490, 42.192830],
                                symbol: `circle`,
                                symbolOffset: [20, -220],//点偏移
                            },
                            {
                                name: '',
                                value: [115.523490, 42.192830],
                                symbol: `circle`,
                                symbolOffset: [60, -200],//点偏移
                            },
                            {
                                name: '',
                                value: [115.523490, 42.192830],
                                symbol: `circle`,
                                symbolOffset: [60, -240],//点偏移
                            },
                            {
                                name: '',
                                value: [115.523490, 42.192830],
                                symbol: `circle`,
                                symbolOffset: [140, -260],//点偏移
                            },
                            {
                                name: '',
                                value: [115.523490, 42.192830],
                                symbol: `circle`,
                                symbolOffset: [100, -300],//点偏移
                            },
                            {
                                name: '',
                                value: [115.523490, 42.192830],
                                symbol: `circle`,
                                symbolOffset: [200, -300],//点偏移
                            },
                            {
                                name: '',
                                value: [115.523490, 42.192830],
                                symbol: `circle`,
                                symbolOffset: [210, -255],//点偏移
                            },
                            {
                                name: '',
                                value: [115.523490, 42.192830],
                                symbol: `circle`,
                                symbolOffset: [10, -300],//点偏移
                            }, {
                                name: '',
                                value: [115.523490, 42.192830],
                                symbol: `circle`,
                                symbolOffset: [270, -290],//点偏移
                            },
                        ]
                    },

                ],
            }
            this.chart.clear();
            this.chart.setOption(option);
            // chart.on('click', (ret) => {
            //     console.log(ret,'wodianle');
            // })
            window.addEventListener('resize', () => {
                this.chart.resize()
            })
        },
        drawssss(geoJson, data) {
            if (data) {
                data.forEach(item => {
                    item.name = item.city
                    item.value = item.account
                    item.code = this.arr[0]
                    // item.value > this.num1 ? (this.num1 = item.value) : (this.num1 = 0)
                    // console.log(this.num1, 'this.num1');
                })
                var arrData = data.map(item => {
                    return item.value
                })
                arrData = arrData.sort((a, b) => {
                    return a - b
                })
                this.num1 = Number((arrData[arrData.length - 1] / 5).toFixed(0))
                this.num2 = Number(arrData[arrData.length - 1])
            }
            console.log(data, 'jaja');
            // console.log(geoJson, 234);
            // console.log(data, 123);
            // 基于准备好的dom，初始化echarts实例
            this.chart = this.$echarts.init(document.getElementById("map"));
            // bayannaoer
            this.$echarts.registerMap("bayannaoer", geoJson);
            // 隐藏动画加载效果。
            this.chart.hideLoading();
            var option = {
                grid: {
                    // top: '30%',
                    // height: "400px",
                    // containLabel: true,
                },
                select: {
                    disabled: true,
                    itemStyle: {
                        areaColor: "#1E88E5",
                        borderColor: "#21bde6",
                        borderWidth: "1"
                    },
                    label: {
                        show: false,
                        color: '#fff',
                        position: 'top'
                    },
                },
                blur: {
                    itemStyle: {
                        areaColor: "#1E88E5",
                        borderColor: "#21bde6",
                        borderWidth: "1"
                    }
                },
                tooltip: {
                    // 提示框
                    trigger: "item",
                    borderColor: "#00E0DB",
                    borderWidth: 1,
                    padding: 5,
                    backgroundColor: "#030b14",
                    extraCssText: "box-shadow: rgba(47, 244, 225, 0.5) 0px 0px 10px;",
                    formatter: (params) => {
                        // console.log(params, 'params');
                        return `
                            <p style="color:#00E0DB;font-size: 20px;">${params.name}</p><br/>
                          
                                  `;
                        //         <p>
                        //  <span style="color: #FFF; font-size: 14px; font-weight: normal;">${params.data.code == "养殖户分布" ? '养殖户数量' : '活畜数量'}<span style="color: #00E0DB; font-size: 16px;">${params.data.value || 0}</span><span style="color: #fff; font-size: 16px; font-weight: normal;">${params.data.code == "养殖户分布" ? "家" : '头'}</span> </span>
                        //         </p>
                    },
                },
                series: [
                    {
                        type: "map", // 系列类型
                        name: "map", // 系列名称
                        zoom: 1,
                        // roam: true,
                        map: "bayannaoer", // 地图类型。echarts-gl 中使用的地图类型同 geo 组件相同(ECharts 中提供了两种格式的地图数据，一种是可以直接 script 标签引入的 js 文件，引入后会自动注册地图名字和数据。还有一种是 JSON 文件，需要通过 AJAX 异步加载后手动注册。)
                        data: data ? data : [],
                        label: {
                            // properties.cp
                            // 标签的相关设置
                            show: false, // (地图上的城市名称)是否显示标签 [ default: false ]
                            // distance: 10, // 标签距离图形的距离，在三维的散点图中这个距离是屏幕空间的像素值，其它图中这个距离是相对的三维距离 标签内容格式器
                            position: 'top',
                            // offset: [-10, 5],
                            textStyle: {
                                // 标签的字体样式
                                color: "white", // 地图初始化区域字体颜色
                                fontSize: 8, // 字体大小
                                opacity: 1, // 字体透明度
                                backgroundColor: "rgba(0,23,11,0)", // 字体背景色
                            },
                        },
                        itemStyle: {
                            // 三维地理坐标系组件 中三维图形的视觉属性，包括颜色，透明度，描边等。
                            // color: "rgba(33,80,231,1)", // 地图板块的颜色
                            color: '#0f3a67',
                            opacity: 1, // 图形的不透明度 [ default: 1 ]
                            borderWidth: 1, // (地图板块间的分隔线)图形描边的宽度。加上描边后可以更清晰的区分每个区域 [ default: 0 ]
                            borderColor: "#37C1FD", // 图形描边的颜色。[ default: #333 ]
                            normal: { // 默认地图区域样式
                                // areaColor: 'rgba(33,80,231,1)',
                                areaColor: "#0f3a67",
                                // borderColor: "#4ECEE6",
                                borderColor: "#165d7d",
                                borderWidth: 1,
                                // shadowColor: "#2C99F6",
                                // shadowOffsetY: 0,
                                // shadowBlur: 25,
                            },
                        },

                        emphasis: {
                            // 鼠标 hover 高亮时图形和标签的样式 (当鼠标放上去时 label和itemStyle 的样式)
                            label: {
                                // label高亮时的配置
                                show: false,
                                textStyle: {
                                    color: "#fff", // 高亮时标签颜色变为 白色
                                    fontSize: 15, // 高亮时标签字体 变大
                                },
                                // formatter: function (params) {
                                //   // console.log(params)
                                //   return params.name
                                // }
                            },
                            itemStyle: {
                                "areaColor": "#1E88E5"
                            }
                        }
                    },
                ],
            }
            this.chart.clear();
            this.chart.setOption(option);
            // chart.on('click', (ret) => {
            //     console.log(ret,'wodianle');
            // })
            window.addEventListener('resize', () => {
                this.chart.resize()
            })
        },
        // 地图
        draw(geoJson, data) {
            if (data) {
                data.forEach(item => {
                    item.name = item.city
                    item.value = item.account
                    item.code = this.arr[1]
                })
                var arrData = data.map(item => {
                    return item.value
                })
                arrData = arrData.sort((a, b) => {
                    return a - b
                })
                if (this.arr[1] == '繁殖率分布') {
                    this.num1 = 20
                    arrData[arrData.length - 1] == 0 || arrData[arrData.length - 1] == undefined || arrData[arrData.length - 1] == null
                        ? this.num2 = '0' : this.num2 = '100%'
                } else {
                    this.num1 = Number((arrData[arrData.length - 1] / 5).toFixed(0))
                    this.num2 = Number(arrData[arrData.length - 1])
                }

            }
            this.pieces = [{
                gte: this.num1 * 4,
                label: `${this.num1 * 4}以上`,
                // color: "#6b3e35"
                color: "#f96921"
            }, {
                gte: this.num1 * 3 + 1,
                lte: this.num1 * 4,
                label: `${this.num1 * 3 + 1} - ${this.num1 * 4}`,
                color: "#f78218"
                // color: "#4a383f"
            },
            {
                gte: this.num1 * 2 + 1,
                lte: this.num1 * 3,
                label: `${this.num1 * 2 + 1}-${this.num1 * 3}`,
                color: "#f2962b"
                // color: "#303345"
            }, {
                gte: this.num1 + 1,
                lte: this.num1 * 2,
                label: `${this.num1 + 1}-${this.num1 * 2}`,
                color: '#f4a52f',
                opacity: 1
                // color: "#192f4d"
            }, {
                gte: 1,
                lte: this.num1,
                label: `1-${this.num1}`,
                // color: "#112e50"
                color: "#fadb72",
                opacity: 1
            }, {
                gte: 0,
                lte: 0,
                // color: "#112e50"
                color: "#10355F",
                opacity: .4,
            }]
            this.pieces_ = [{
                gte: this.num1 * 4,
                label: `${this.num1 * 4}%以上`,
                // color: "#6b3e35"
                color: "#f96921"
            }, {
                gte: this.num1 * 3 + 1,
                lte: this.num1 * 4,
                label: `${this.num1 * 3 + 1}% - ${this.num1 * 4}%`,
                color: "#f78218"
                // color: "#4a383f"
            },
            {
                gte: this.num1 * 2 + 1,
                lte: this.num1 * 3,
                label: `${this.num1 * 2 + 1}%-${this.num1 * 3}%`,
                color: "#f2962b"
                // color: "#303345"
            }, {
                gte: this.num1 + 1,
                lte: this.num1 * 2,
                label: `${this.num1 + 1}%-${this.num1 * 2}%`,
                color: '#f4a52f',
                opacity: 1
                // color: "#192f4d"
            }, {
                gte: 1,
                lte: this.num1,
                label: `1-${this.num1}%`,
                // color: "#112e50"
                color: "#fadb72",
                opacity: 1
            }, {
                gte: 0,
                lte: 0,
                // color: "#112e50"
                color: "#10355F",
                opacity: .4,
            }]
            // console.log(data, 'data');
            // console.log(geoJson,'123');
            // 基于准备好的dom，初始化echarts实例
            // document.getElementById("mapBox").innerHTML = ''
            // console.log(data)
            this.chart = this.$echarts.init(document.getElementById("map"));
            // geoJson.features.forEach((item) => {
            //     item['properties']['cp'] = item.properties.center
            // })
            this.$echarts.registerMap("bayannaoer", geoJson);
            // 隐藏动画加载效果。
            this.chart.hideLoading();
            var option = {
                tooltip: {
                    show:false,
                    // 提示框
                    trigger: "item",
                    borderColor: "#00E0DB",
                    borderWidth: 1,
                    padding: 5,
                    backgroundColor: "#030b14",
                    extraCssText: "box-shadow: rgba(47, 244, 225, 0.5) 0px 0px 10px;",
                    formatter: (params) => {
                        // console.log(params, 'params');
                        // if () {

                        // }
                        return `
                        <p style="color:#00E0DB;font-size: 20px;">${params.data.name}</p><br/>
                        <p>
                       <span style="color: #FFF; font-size: 14px; font-weight: normal;">${params.data.code == "存栏分布" ? '存栏分布' : params.data.code == "疾病分布" ? '疾病分布' : this.arr[1] == "繁殖率分布" ? '繁殖率分布' : ''}
                        <span style="color: #00E0DB; font-size: 16px;">${this.arr[1] == "繁殖率分布" ? (params.data.value || 0) + '%' : params.data.value || 0}</span><span style="color: #fff; font-size: 16px; font-weight: normal;">${this.arr[1] == "繁殖率分布" ? "" : '头(只)'}</span> </span>
                              </p>
                              `;
                        // <p>
                        //   <span style="color: #FFF; font-size: 14px; font-weight: normal;">畜牧科技师服务养殖户占比<span style="color: #00E0DB; font-size: 16px;">${params.data.proportion || 0}</span></span>
                        // </p>
                        // return params.name
                    },
                },
                grid: {
                    // top: '-5%',
                    // show:true
                },
                series: [
                    {
                        type: "map3D", // 系列类型
                        name: "map3D", // 系列名称
                        zoom: 1,
                        map: "bayannaoer", // 地图类型。echarts-gl 中使用的地图类型同 geo 组件相同(ECharts 中提供了两种格式的地图数据，一种是可以直接 script 标签引入的 js 文件，引入后会自动注册地图名字和数据。还有一种是 JSON 文件，需要通过 AJAX 异步加载后手动注册。)
                        data: data ? data : [],
                        top: '-1%',
                        // bottom:'50%',
                        label: {
                            // properties.cp
                            // 标签的相关设置
                            show: false, // (地图上的城市名称)是否显示标签 [ default: false ]
                            // distance: 10, // 标签距离图形的距离，在三维的散点图中这个距离是屏幕空间的像素值，其它图中这个距离是相对的三维距离 标签内容格式器
                            position: 'top',
                            // offset: [-10, 5],
                            textStyle: {
                                // 标签的字体样式
                                color: "white", // 地图初始化区域字体颜色
                                fontSize: 12, // 字体大小
                                opacity: 1, // 字体透明度
                                backgroundColor: "rgba(0,23,11,0)", // 字体背景色
                            },
                            // align: 'center',
                            // verticalAlign: 'middle'
                            // normal: {
                            //     show: true,
                            //     color: 'rgba(5, 176, 220, 1)',
                            //     fontSize: 1, //此处字体需做兼容适配

                            //     align: 'left',
                            //     verticalAlign: 'middle',
                            //     position: 'inside',
                            //     distance: 15,
                            // },
                            // emphasis: {
                            //     show: true,
                            //     color: '#ececec'
                            // }
                        },
                        itemStyle: {
                            // 三维地理坐标系组件 中三维图形的视觉属性，包括颜色，透明度，描边等。
                            // color: "rgba(33,80,231,1)", // 地图板块的颜色
                            color: '#17478F',
                            opacity: 1, // 图形的不透明度 [ default: 1 ]
                            borderWidth: 1, // (地图板块间的分隔线)图形描边的宽度。加上描边后可以更清晰的区分每个区域 [ default: 0 ]
                            borderColor: "#00ffff", // 图形描边的颜色。[ default: #333 ]
                        },

                        emphasis: {
                            // 鼠标 hover 高亮时图形和标签的样式 (当鼠标放上去时 label和itemStyle 的样式)
                            label: {
                                // label高亮时的配置
                                show: false,
                                textStyle: {
                                    color: "#fff", // 高亮时标签颜色变为 白色
                                    fontSize: 15, // 高亮时标签字体 变大
                                },
                                // formatter : function(params) {
                                //     console.log(params)
                                // }
                            },
                            itemStyle: {
                                "color": "#00E0DB"
                            }
                        },
                        groundPlane: {
                            // 地面可以让整个组件有个“摆放”的地方，从而使整个场景看起来更真实，更有模型感。
                            show: false, // 是否显示地面。[ default: false ]
                            color: "#aaa", // 地面颜色。[ default: '#aaa' ]
                        },
                        light: {
                            // 光照相关的设置。在 shading 为 'color' 的时候无效。 光照的设置会影响到组件以及组件所在坐标系上的所有图表。合理的光照设置能够让整个场景的明暗变得更丰富，更有层次。
                            main: {
                                // 场景主光源的设置，在 globe 组件中就是太阳光。
                                color: "#fff", //主光源的颜色。[ default: #fff ]
                                intensity: 1.2, //主光源的强度。[ default: 1 ]
                                shadow: false, //主光源是否投射阴影。默认关闭。 开启阴影可以给场景带来更真实和有层次的光照效果。但是同时也会增加程序的运行开销。
                                shadowQuality: "medium", // 阴影的质量。可选'low', 'medium', 'high', 'ultra' [ default: 'medium' ]
                                alpha: 55, // 主光源绕 x 轴，即上下旋转的角度。配合 beta 控制光源的方向。[ default: 40 ]
                                beta: 10, // 主光源绕 y 轴，即左右旋转的角度。[ default: 40 ]
                            },
                        },

                        viewControl: {
                            // 用于鼠标的旋转，缩放等视角控制。
                            projection: "perspective", // 投影方式，默认为透视投影'perspective'，也支持设置为正交投影'orthographic'。
                            autoRotate: false, // 是否开启视角绕物体的自动旋转查看。[ default: false ]
                            autoRotateDirection: "cw", // 物体自传的方向。默认是 'cw' 也就是从上往下看是顺时针方向，也可以取 'ccw'，既从上往下看为逆时针方向。
                            autoRotateSpeed: 10, // 物体自传的速度。单位为角度 / 秒，默认为10 ，也就是36秒转一圈。
                            autoRotateAfterStill: 3, // 在鼠标静止操作后恢复自动旋转的时间间隔。在开启 autoRotate 后有效。[ default: 3 ]
                            damping: 0, // 鼠标进行旋转，缩放等操作时的迟滞因子，在大于等于 1 的时候鼠标在停止操作后，视角仍会因为一定的惯性继续运动（旋转和缩放）。[ default: 0.8 ]
                            rotateSensitivity: 0, // 旋转操作的灵敏度，值越大越灵敏。支持使用数组分别设置横向和纵向的旋转灵敏度。默认为1, 设置为0后无法旋转。 rotateSensitivity: [1, 0]——只能横向旋转； rotateSensitivity: [0, 1]——只能纵向旋转。
                            zoomSensitivity: 0, // 缩放操作的灵敏度，值越大越灵敏。默认为1,设置为0后无法缩放。
                            panSensitivity: 1, // 平移操作的灵敏度，值越大越灵敏。默认为1,设置为0后无法平移。支持使用数组分别设置横向和纵向的平移灵敏度
                            panMouseButton: "left", // 平移操作使用的鼠标按键，支持：'left' 鼠标左键（默认）;'middle' 鼠标中键 ;'right' 鼠标右键(注意：如果设置为鼠标右键则会阻止默认的右键菜单。)
                            rotateMouseButton: "left", // 旋转操作使用的鼠标按键，支持：'left' 鼠标左键;'middle' 鼠标中键（默认）;'right' 鼠标右键(注意：如果设置为鼠标右键则会阻止默认的右键菜单。)
                            orthographicSize: 60,
                            // distance: 200, 
                            distance:  this.mapDistance, // [ default: 100 ] 默认视角距离主体的距离，对于 grid3D 和 geo3D 等其它组件来说是距离中心原点的距离,对于 globe 来说是距离地球表面的距离。在 projection 为'perspective'的时候有效。
                            minDistance: 40, // [ default: 40 ] 视角通过鼠标控制能拉近到主体的最小距离。在 projection 为'perspective'的时候有效。
                            maxDistance: 400, // [ default: 400 ] 视角通过鼠标控制能拉远到主体的最大距离。在 projection 为'perspective'的时候有效。
                            alpha: 70, // 视角绕 x 轴，即上下旋转的角度。配合 beta 可以控制视角的方向。[ default: 40 ]
                            beta: 10, // 视角绕 y 轴，即左右旋转的角度。[ default: 0 ]
                            // minAlpha: -45, // 上下旋转的最小 alpha 值。即视角能旋转到达最上面的角度。[ default: 5 ]
                            // maxAlpha: 45, // 上下旋转的最大 alpha 值。即视角能旋转到达最下面的角度。[ default: 90 ]
                            // minBeta: -45, // 左右旋转的最小 beta 值。即视角能旋转到达最左的角度。[ default: -80 ]
                            // maxBeta: 45, // 左右旋转的最大 beta 值。即视角能旋转到达最右的角度。[ default: 80 ]
                            // center: [0, 0, 0], // 视角中心点，旋转也会围绕这个中心点旋转，默认为[0,0,0]。
                            animation: true, // 是否开启动画。[ default: true ]
                            animationDurationUpdate: 1000, // 过渡动画的时长。[ default: 1000 ]
                            animationEasingUpdate: "cubicInOut", // 过渡动画的缓动效果。[ default: cubicInOut ]
                        },
                    },
                ],
                visualMap: {
                    show:false,
                    type: 'continuous',
                    show: false,
                    min: 0,
                    max: this.num1 ? this.num1 * 4 : 0, //控制根据返回值  控制数量
                    right: -5,
                    bottom: 20,
                    itemWidth: 13,//图形的宽度，即长条的宽度。
                    itemHeight: 80,
                    // showLabel: !0,
                    text: [`${this.num2}`, '0'],
                    // realtime: false,
                    // calculable: true,
                    inRange: {
                        color: this.num2 && this.num2 != 0 ? ['rgba(16,53,95,0.4)', 'rgba(250,219,114,1)', 'rgba(244,165,47,1)',
                            'rgba(242,150,43,1)', 'rgba(247,130,24,1)', 'rgba(249,105,33,1)'] : ['rgba(16,53,95,0.4)']  //显示颜色
                    },
                    // continuous: {
                    //     type: 'piecewise',
                    // itemGap: 12,
                    align: 'left',
                    // itemSymbol: 'circle',
                    // itemWidth: 8,
                    // itemHeight: 8,
                    textStyle: { color: '#fff' },
                    pieces: this.arr[1] == '繁殖率分布' ? this.pieces_ : this.pieces
                },

            };

            this.chart.setOption(option)
            window.addEventListener('resize', () => {
                this.chart.resize()
            })
            // this.chart.on('click', (params) => {
            //     // console.log(params);
            //     this.region.features.forEach((item) => {
            //         if (item.properties.name == params.name) {
            //             this.childMap.filter(item => {
            //                 if (item.name == params.name) {
            //                     this.paramsName = params.name
            //                     this.childMapData = item.childMap
            //                 }
            //             })
            //             // console.log(item.properties.name);
            //             var adcode = item.properties.adcode
            //             this.$http({
            //                 url: 'screenapp-service/map/child/data',
            //                 //请求方式
            //                 method: 'post',
            //                 //传递的参数
            //                 data: {
            //                     adcode: adcode,
            //                 },
            //             }).then(res => {
            //                 if (res.data.code === 200) {
            //                     if (this.chart != null && this.chart != "" && this.chart != undefined) {
            //                         this.isShowMap = false
            //                     }
            //                     this.$nextTick(() => {
            //                         this.isShowMap = true
            //                         this.goBackShow = true
            //                         this.$nextTick(() => {
            //                             this.region = res.data.result.map
            //                             this.draw(this.region, this.childMapData)
            //                         })
            //                     })
            //                 }
            //             })
            //         }
            //     })


            // });
        },

    },
};
</script>
<style lang="scss" scoped>
.main {
    width: 100%;

    .bank_title {
        position: relative;

        .gobcak {
            width: .875rem;
            height: .4375rem;
            position: absolute;
            z-index: 99;
            bottom: -0.25rem;
            left: 0.25rem;
            font-size: .2rem;
            font-family: HarmonyOS Sans SC-Regular, HarmonyOS Sans SC;
            font-weight: 400;
            color: #00E0DB;
            display: flex;
            align-items: center;
            cursor: pointer;

            img {
                width: .3rem;
                height: .3rem;
            }

            span {
                margin-left: .05rem;
            }
        }
    }

    .content {
        position: relative;
        padding: .2rem .25rem;
        box-sizing: border-box;
        min-height: 12.5rem;
        // min-height: calc(100vh - 1rem);
        // background: url('../../assets/bg-hhr.png');
        // background-size: 100% 100%;

        // display: flex;

        video {
            position: absolute;
            top: 0;
            left: 0;
            z-index: -1;
            width: 100%;
            height: 100%;
        }

        .head {
            width: 100%;
            height: 1.17rem;
            display: flex;

            // background-color: red;
            .top_item {
                display: flex;
                flex-direction: column;
                align-items: center;
                margin-left: 1.8rem;
                min-width: 3rem;

                span {
                    font-size: 0.175rem;
                    font-family: Source Han Sans CN-Regular, Source Han Sans CN;
                    font-weight: 400;
                    color: #FFFFFF;
                    text-align: center;
                }

                .small_big {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    width: 2rem;
                    height: 0.75rem;
                    background: rgba(0, 223, 218, 0.08);
                    opacity: 1;
                    font-size: 0.5rem;
                    font-family: 汉仪菱心体简-regular, 汉仪菱心体简;
                    font-weight: 400;
                    color: #FFE11D;
                    position: relative;
                    margin-top: .18rem;

                    span {
                        font-size: .2rem;
                        font-family: 汉仪菱心体简-regular, 汉仪菱心体简;
                        font-weight: 400;
                        color: #FFE11D;
                        padding-top: 0.2rem;
                    }

                    &::after {
                        position: absolute;
                        left: 0;
                        top: 0;
                        content: "";
                        width: 0.13rem;
                        height: 0.13rem;
                        opacity: 1;
                        border-left: 0.01rem solid rgba(0, 224, 219, 0.3);
                        border-top: 0.01rem solid rgba(0, 224, 219, 0.3);
                    }

                    &::before {
                        position: absolute;
                        right: 0;
                        top: 0;
                        content: "";
                        width: 0.13rem;
                        height: 0.13rem;
                        opacity: 1;
                        border-top: 0.01rem solid rgba(0, 224, 219, 0.3);
                        border-right: 0.01rem solid rgba(0, 224, 219, 0.3);
                    }

                    .top_box {
                        position: absolute;
                        bottom: 0;
                        left: 0;
                        width: 100%;
                        height: .3rem;

                        &::after {
                            position: absolute;
                            left: 0;
                            bottom: 0;
                            content: "";
                            width: 0.13rem;
                            height: 0.13rem;
                            opacity: 1;
                            border-left: 0.01rem solid rgba(0, 224, 219, 0.3);
                            border-bottom: 0.01rem solid rgba(0, 224, 219, 0.3);
                        }

                        &::before {
                            position: absolute;
                            right: 0;
                            bottom: 0;
                            content: "";
                            width: 0.13rem;
                            height: 0.13rem;
                            opacity: 1;
                            border-bottom: 0.01rem solid rgba(0, 224, 219, 0.3);
                            border-right: 0.01rem solid rgba(0, 224, 219, 0.3);
                        }
                    }
                }
            }
        }

        .foot {
            display: flex;
            margin-top: .36rem;

            .left {

                width: 6.25rem;
                height: 10.5rem;

                .l_t {
                    height: 4.38rem;
                    border-left: 0.01rem solid rgba(0, 224, 219, 0.3);
                    background: linear-gradient(119deg, rgba(0, 222, 217, 0.1) 19%, rgba(0, 223, 218, 0) 88%);

                    #barChart {
                        width: 100%;
                        height: 3.4rem;
                        margin-top: .35rem;
                        // margin: .35rem .25rem 0 .25rem;
                    }

                    .date {
                        span {
                            display: inline-block;
                            width: 0.44rem !important;
                            height: 0.23rem !important;
                            text-align: center;
                            line-height: .23rem;
                            padding: 0;
                        }
                    }
                }

                .l_b {
                    height: 5.87rem;
                    border-left: 0.01rem solid rgba(0, 224, 219, 0.3);
                    background: linear-gradient(74deg, rgba(0, 222, 217, 0.1) 19%, rgba(0, 223, 218, 0) 88%);
                    margin-top: .25rem;



                    #lineChart_1 {
                        width: 100%;
                        height: 3.7rem;
                        margin-top: 0.5rem;
                    }
                }
            }

            .center {
                flex: 1;
                // background-color: red;
                margin: 0 .25rem;

                .center_top {
                    display: flex;
                    align-items: center;
                    justify-content: space-evenly;
                    margin-top: .15rem;
                    font-size: 0.23rem;
                    font-family: Source Han Sans CN-Regular, Source Han Sans CN;
                    font-weight: 400;
                    color: #A3D8D6;

                    img {
                        cursor: pointer;
                    }

                    span {
                        // width: 1.5rem;
                        // margin: 0 .78rem;
                        cursor: pointer;
                    }

                    span:nth-child(3) {
                        margin: 0;
                    }

                }

                .date {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    margin-top: .29rem;
                    color: #7B8A89;
                    // margin-left: .2rem;
                    margin-left: -0.8rem;

                    span {
                        padding: .03rem .05rem;
                        border-radius: 0.03rem 0.03rem 0.03rem 0.03rem;
                        font-size: 0.13rem;
                        font-family: Source Han Sans CN-Regular, Source Han Sans CN;
                        background: rgba(255, 255, 255, 0.05);
                        opacity: .5;
                        font-weight: 400;
                        cursor: pointer;
                    }

                    span:nth-child(2) {
                        margin: 0 .13rem;
                    }
                }

                .span_item {
                    width: 100%;
                    height: .53rem;
                }

                #map {
                    width: 100%;
                    height: 6.4rem;
                    margin-top: .25rem;
                }

                .bottom {
                    margin-top: .3rem;
                    width: 100%;
                    height: 2.5rem;
                    background: linear-gradient(360deg, rgba(0, 222, 217, 0.1) 23%, rgba(0, 223, 218, 0) 63%);
                    border-bottom: 0.01rem solid rgba(0, 224, 219, 0.3);

                    .date {
                        margin-top: 0 !important;
                        padding-right: 0.25rem;
                    }

                    .bottom_ {
                        display: flex;
                        align-items: center;
                        margin-top: .48rem;
                        margin-left: .39rem;

                        .round {
                            width: 1.25rem;
                            height: 1.25rem;
                            position: relative;

                            span {
                                position: absolute;
                                bottom: 0.3rem;
                                left: 0.35rem;
                                color: #010E26;
                                font-size: 0.18rem !important;
                                font-family: Source Han Sans CN-Medium, Source Han Sans CN !important;
                                font-weight: 500 !important;
                                z-index: 99;
                            }

                            span:nth-child(1) {
                                position: absolute;
                                bottom: 0.55rem;
                                left: 0.35rem;
                                font-size: 0.23rem;
                                font-family: Source Han Sans CN-Medium, Source Han Sans CN;
                                font-weight: 500;
                                color: #010E26;
                                z-index: 99;
                            }
                        }

                        .bottom_item {
                            display: flex;
                            align-items: center;
                            margin-left: 1.5rem;

                            .col {
                                width: 0.08rem;
                                height: 0.38rem;
                                border-radius: 1.25rem 1.25rem 1.25rem 1.25rem;
                                opacity: 1;
                            }

                            .item {
                                margin-left: .24rem;
                                display: flex;
                                flex-direction: column;
                                font-size: 0.15rem;
                                font-family: Source Han Sans CN-Regular, Source Han Sans CN;
                                font-weight: 400;
                                color: #A3D8D6;

                                span:nth-child(2) {
                                    font-size: 0.23rem;
                                    font-family: Source Han Sans CN-Medium, Source Han Sans CN;
                                    font-weight: 500;
                                    color: #FAFAFA;
                                    margin-top: .2rem;
                                }
                            }
                        }
                    }
                }
            }

            .right {
                width: 6.25rem;
                height: 10.5rem;
                // background: linear-gradient(265deg, rgba(0, 223, 218, 0.1) 39%, rgba(0, 223, 218, 0.01) 74%);
                background: linear-gradient(-78deg, rgba(0, 223, 218, 0.08) 8%, rgba(0, 223, 218, 0.1) 38%, rgba(0, 223, 218, 0) 80%);
                border-right: 0.01rem solid rgba(0, 224, 219, 0.3);


                .add {

                    .add_item {
                        div {
                            min-width: 2.5rem;
                        }
                    }
                }

                #lineChart_2 {
                    width: 100%;
                    height: 3.5rem;
                    margin-top: 0.34rem;
                }

                .block_ {
                    margin-top: .38rem;
                    margin-left: .25rem;
                    display: flex;
                    justify-content: space-between;
                    align-items: center;

                    .block_item {
                        display: flex;
                        align-items: center;

                        span:nth-child(1) {
                            display: inline-block;
                            width: 0.11rem;
                            height: 0.2rem;
                            background: #00E0DB;
                            opacity: 1;
                        }


                        span:nth-child(2) {
                            margin-left: .15rem;
                            font-size: 0.2rem;
                            font-family: Source Han Sans CN-Bold, Source Han Sans CN;
                            font-weight: bold;
                            color: #00E0DB;
                        }
                    }

                    .date {
                        // margin-left: 1.2rem;
                        color: #7B8A89;
                        padding-right: 0.15rem;

                        span {
                            display: inline-block;
                            width: 0.44rem !important;
                            height: 0.23rem !important;
                            text-align: center;
                            line-height: .23rem;
                            // padding: .03rem .05rem;
                            border-radius: 0.03rem 0.03rem 0.03rem 0.03rem;
                            font-size: 0.13rem;
                            font-family: Source Han Sans CN-Regular, Source Han Sans CN;
                            background: rgba(255, 255, 255, 0.05);
                            opacity: .5;
                            font-weight: 400;
                            cursor: pointer;
                        }

                        span:nth-child(2) {
                            margin: 0 .13rem;
                        }
                    }
                }
            }
        }


    }

    .server {
        display: flex;
        justify-content: space-between;
        align-items: center;
        height: 0.48rem;
        background: linear-gradient(119deg, rgba(0, 222, 217, 0.3) 19%, rgba(0, 223, 218, 0) 88%);

        // padding-top: .24rem;
        .card_ {
            font-size: 0.23rem;
            font-family: SourceHanSansCN-Regular, SourceHanSansCN;
            font-weight: 400;
            color: #00E0DB;
            padding-left: .25rem;
        }

        .date {
            // margin-left: 1.2rem;
            color: #7B8A89;
            padding-right: 0.15rem;

            span {
                padding: .03rem .05rem;
                border-radius: 0.03rem 0.03rem 0.03rem 0.03rem;
                font-size: 0.13rem;
                font-family: Source Han Sans CN-Regular, Source Han Sans CN;
                background: rgba(255, 255, 255, 0.05);
                opacity: .5;
                font-weight: 400;
                cursor: pointer;
            }

            span:nth-child(2) {
                margin: 0 .13rem;
            }
        }
    }

    .active {
        background: rgba(255, 255, 255, 0.2) !important;
        // opacity: 1;
        color: #00E0DB !important;
        opacity: 1 !important;
    }

    .add {
        display: flex;
        margin-top: .5rem;
        margin-left: .5rem;

        .add_item {
            display: flex;
            flex-direction: column;
            margin-right: 0.2rem;

            div {
                font-size: 0.15rem;
                font-family: Source Han Sans CN-Regular, Source Han Sans CN;
                font-weight: 400;
                color: #FFFFFF;
                line-height: 0.18rem;
                padding-top: .1rem;

                span:nth-child(2) {
                    margin-left: .14rem;
                    font-size: 0.15rem;
                    font-family: Source Han Sans CN-Medium, Source Han Sans CN;
                    font-weight: 500;
                    color: #FF5A0D;
                    line-height: 0.18rem;

                    i {
                        font-style: normal;
                    }
                }

                img {
                    margin-left: .1rem !important;
                }
            }

            .num {
                display: block;
                font-size: 0.38rem;
                font-family: Source Han Sans CN-Bold, Source Han Sans CN;
                font-weight: bold;
                color: #00E0DB;
                // line-height: 0.38rem;
                // padding-top: .11rem;
                // padding-left: .08rem;
            }

            div {
                min-width: 3rem;
            }

        }
    }

    .active_1 {
        color: #00FF9D !important;
    }

    .active_2 {
        font-size: 0.3rem;
        font-family: Source Han Sans CN-Bold, Source Han Sans CN;
        font-weight: bold;
        color: #00E0DB;
    }

    .block {
        margin-top: .38rem;
        margin-left: .25rem;
        display: flex;
        align-items: center;

        span:nth-child(1) {
            width: 0.11rem;
            height: 0.2rem;
            background: #00E0DB;
            border-radius: 0rem 0rem 0rem 0rem;
            opacity: 1;
        }


        span:nth-child(2) {
            margin-left: .15rem;
            font-size: 0.2rem;
            font-family: Source Han Sans CN-Bold, Source Han Sans CN;
            font-weight: bold;
            color: #00E0DB;
        }
    }
}
</style>
<style lang="scss">
.breeder {

    // DataV
    .dv-scroll-ranking-board .ranking-column {
        height: 0.15rem;
        background: #102c41;
        border: none;
        border-radius: 0.6rem 0.6rem 0.6rem 0.6rem !important;
        margin-top: 5px;
    }

    .dv-scroll-ranking-board .ranking-column .inside-column {
        width: 5.5rem;
        height: 0.15rem;
        background: linear-gradient(270deg, #FFE11D 0%, #00E0DB 100%) !important;
        border-radius: 0.6rem 0.6rem 0.6rem 0.6rem !important;
        margin-bottom: 0;
        overflow: hidden;
    }

    .dv-scroll-ranking-board .ranking-column .shine {
        background-color: transparent !important;
        animation: none !important;
    }

    .dv-scroll-ranking-board .ranking-info .rank {
        font-size: 0.18rem;
        font-family: Source Han Sans CN-Regular, Source Han Sans CN;
        font-weight: 400;
        color: #FFFFFF;
    }

    .dv-scroll-ranking-board .ranking-info .info-name {
        font-size: 0.18rem;
        font-family: Source Han Sans CN-Regular, Source Han Sans CN;
        font-weight: 400;
        color: #FFFFFF;
    }

    .ranking-value {
        font-size: 0.15rem;
        font-family: Source Han Sans CN-Medium, Source Han Sans CN;
        font-weight: 500;
        color: #FFE11D;
    }

    .dv-water-pond-level canvas {
        border: 1px solid #21EEE9;
        margin-left: .09rem;
        margin-top: .09rem;
    }

    .dv-water-pond-level text {
        font-size: 0.23rem !important;
        font-family: Source Han Sans CN-Medium, Source Han Sans CN !important;
        font-weight: 500 !important;
        color: #010E26 !important;
        opacity: 0 !important;

    }

}
</style>